const NoAvailableFeature = () =>
  <>
    If your new feature is not listed above, please
    refresh this page. Save your test config beforehand
    to avoid losing changes.
  </>

export default NoAvailableFeature
